import { render, staticRenderFns } from "./p04.vue?vue&type=template&id=2bc4d4e6&scoped=true&"
import script from "./p04.vue?vue&type=script&lang=js&"
export * from "./p04.vue?vue&type=script&lang=js&"
import style0 from "./p04.vue?vue&type=style&index=0&id=2bc4d4e6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc4d4e6",
  null
  
)

export default component.exports